import { Pipe, PipeTransform } from '@angular/core';
import {
  TechChangeAgentDashboardListDto,
  TechChangeCombinedSummaryResponseDto,
  TechChangeMonthlyExportSummaryResponseDto,
  TechChangeMonthlySummaryResponseDto,
} from 'src/app/shared/dto';

type TechChangeSummary =
  | TechChangeCombinedSummaryResponseDto
  | TechChangeMonthlySummaryResponseDto
  | TechChangeMonthlyExportSummaryResponseDto;

const NO_AGENT_REASON = 'View all only available when an individual New Technology Agent is selected.';
const NOT_RUN_REASON = 'View all is disabled while this agent has not run yet.';
const NO_REPORT_REASON = "View all is unavailable — we couldn't retrieve the corresponding report.";

@Pipe({
  name: 'techChangeViewAllDisabledReason',
  standalone: true,
})
export class TechChangeViewAllDisabledReasonPipe implements PipeTransform {
  transform(
    agent: TechChangeAgentDashboardListDto | null | undefined,
    reportSummary: TechChangeSummary | null | undefined,
  ): string {
    if (!agent) {
      return NO_AGENT_REASON;
    }
    if (!reportSummary) {
      return '';
    }

    const weeklySummary = reportSummary.weekly_summary || [];
    const total = weeklySummary.reduce(
      (sum, entry) => sum + (entry.total_company_count || 0) + (entry.total_contact_count || 0) + (entry.all_companies_count || 0),
      0,
    );
    if (total === 0) {
      return NOT_RUN_REASON;
    }

    if (!reportSummary.tech_card_summary_detail?.report_id) {
      return NO_REPORT_REASON;
    }

    return '';
  }
}
